























































import Vue from 'vue'
import { pickBy } from 'lodash'
import { Button, Select, Option } from 'element-ui'
import { UserProfile } from '@/types/users'
import UserProfileForm from '@/components/UserProfileForm'
import PrivateCall from '@/components/PrivateCall'
import { KeyDict } from '@/types'
import { TranscodingRegion } from '@/types/admin'
import { CallTriage, Cast, InvitedCaster } from '@/types/casts'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import './Interview.scss'

export default Vue.extend({
  name: 'Interview',
  data: () => ({
    editProfile: { encoderSettings: {} } as UserProfile,
    assignProfileId: null,
    showLoader: false,
    needsRepublishing: {} as KeyDict<boolean>
  }),
  props: {
    castId: {
      type: String,
      required: true
    },
    guest: {
      type: Object as () => UserProfile | undefined,
      required: true
    },
    moderator: {
      type: Object as () => UserProfile | undefined,
      required: true
    },
    showProfileForm: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  created () {
    if (this.guest === undefined) return
    this.setEditProfile(this.guest)
  },
  computed: {
    currentTeam (): UserProfile[] {
      return this.$store.direct.state.team.currentTeam
    },
    activeTeamId (): string {
      return this.$store.direct.state.team.activeTeam
    },
    transcodingregions (): KeyDict<TranscodingRegion> {
      return this.$store.direct.state.admin.transcodingregions
    },
    currentCast (): Cast | null {
      return this.$store.direct.state.events.currentCast
    },
    invitedCasters (): KeyDict<InvitedCaster> {
      return this.currentCast?.invited_casters ?? {}
    },
    assignableProfiles (): UserProfile[] {
      const activeInvitedCasters = this.$store.direct.getters.events.activeInvitedCasters
      const casterIds = Object.keys(activeInvitedCasters)
      const onlineIds = Object.keys(this.onlineUsers)
      return this.currentTeam.filter((profile) => !profile.anonymous && casterIds.includes(profile.id) && !onlineIds.includes(profile.id))
    },
    onlineUsers (): KeyDict<string[]> {
      const onlineUsers = this.$store.direct.state.events.currentCast.online_sessions
      return pickBy(onlineUsers, (sessions) => sessions.length > 0)
    },
  },
  watch: {
    guest (newVal: UserProfile) {
      this.setEditProfile(newVal)
    }
  },
  methods: {
    async updateGuestCaster (triage: CallTriage) {
      if (!this.guest?.id || !this.moderator?.id) return
      const payload = { userId: this.guest.id, triage: triage, moderatorId: this.moderator.id }
      await this.$store.direct.dispatch.events.setCasterTriage(payload)
    },
    async rejectGuest () {
      try {
        await this.updateGuestCaster(CallTriage.Rejected)
        this.$message({ type: 'success', message: 'User rejected' })
      } catch (error) {
        this.$message({ type: 'error', message: 'Something went wrong' })
        this.addLog('Unable to reject guest', 'error', { error, guest: this.guest, moderator: this.moderator })
      }
    },
    async acceptGuest () {
      this.showLoader = true
      try {
        await this.updateGuestProfile(false)
        await this.updateGuestCaster(CallTriage.Accepted)
        this.$message({ type: 'success', message: 'User accepted' })
      } catch (error) {
        this.$message({ type: 'error', message: 'Something went wrong' })
        this.addLog('Unable to accept guest', 'error', { error, guest: this.guest, moderator: this.moderator })
      } finally {
        this.showLoader = false
      }
    },
    setNeedsRepublishing (newVal: { user_id: string, val: boolean}){
      this.needsRepublishing[newVal.user_id] = newVal.val
    },
    async updateGuestProfile (showMessage: boolean = true) {
      try {
        const updatedProfile = JSON.parse(JSON.stringify(this.editProfile))
        updatedProfile.teamid = this.activeTeamId
        await this.$store.direct.dispatch.team.updateTeamMember(updatedProfile)
        const memberId = this.editProfile.id
        if(this.needsRepublishing[memberId] === true) {
          this.requestCasterRepublish(memberId)
          this.needsRepublishing[memberId] = false
        }
        if (showMessage) this.$message({ type: 'success', message: 'User updated' })
      } catch (error) {
        console.error('Interview.vue:updateGuestProfile', error)
        this.addLog('Unable to update guest profile', 'error', { error, guest: this.guest, moderator: this.moderator })
      }
    },
    requestCasterRepublish (casterId: string) {
      this.$emit('requestCasterRepublish', casterId)
    },
    assignAnonymousCaster (): void {
      if (this.assignProfileId) {
        this.$emit('assignAnonymousCaster', this.assignProfileId)
      } else {
        this.$message({
          type: 'error',
          message: 'Please select a profile to assign to'
        })
      }
    },
    setEditProfile (profile: UserProfile) {
      this.editProfile = { encoderSettings: {} , ...profile }
    },
    addLog (message: string, level, data: any): void {
      this.$store.direct.dispatch.logs.addLog({
        message: message,
        data: { ...data },
        level: level
      })
    }
  },
  components: {
    UserProfileForm,
    PrivateCall,
    ClipLoader,
    'el-button': Button,
    'el-select': Select,
    'el-option': Option
  }
})

